import { isEmpty, get, merge, isString } from 'lodash';
import queryString from 'query-string';

// local dependencies
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*-----------------*/

// serialize an `object` to query string parameters (a=b&c=d notation)
const convertObjectToParams = ( payload ) => {
	return queryString.stringify( payload );
};

// parse incoming URL string into an object with endpoint and query params
const parseUrl = ( url ) => {
    return queryString.parseUrl( url );
};

/*-----------------*/

/**
 * @type {function}
 * @desc An utility function to add query parameters to the path.
 * @oaram payload - `string` or `{refId: string, params: object}`
 * @example
 * import { addParamsToPath } from 'utils/addParamsToPath';
 * const result = addParamsToPath( ...args );
 */
export const addParamsToPath = ( payload, extraParams = {} ) => {
    try {

		// when payload is a string
		if( isString( payload ) ) {

			// parse URL from the payload (string)
			const URL = parseUrl( payload );

			// merge `URL.query` with `extraParams`
			const _payload = merge( {}, URL.query, extraParams );

			// return fully-qualified URL back
			return isEmpty( _payload ) ? URL.url : `${ URL.url }?${ convertObjectToParams( _payload ) }`;

		} else {

			// get URL from the redux store
			const url = get( store.getState()[ REDUCER.URLS ], payload.refId, payload );

			// parse URL from the payload (string)
			const URL = parseUrl( url );

			// merge `URL.query` with `extraParams`
			const _payload = merge( {}, URL.query, payload.params, extraParams );

			// return fully-qualified URL back
			return isEmpty( _payload ) ? URL.url : `${ URL.url }?${ convertObjectToParams( _payload ) }`;

		}
	} catch ( error ) {
		console.warn( 'Invalid URL' );
	}
};
